// Source: user-provided FREYA TARIFLER.pdf, 24 September 2026.
// Total times for salmon and toast are the sums of the source timings.
window.FREYA_RECIPES = [
  {
    "slug": "incir-balsamik-soslu-marine-somon",
    "title": "İncir Balsamik Soslu Marine Somon",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-somon.webp?v=1790406130",
    "product": "İncir Balsamik Sos",
    "productSlug": "incir-balsamik-sos",
    "summary": "İncir balsamik sosuyla marine edilen somon, tavada sotelenmiş kuşkonmazla birlikte.",
    "serves": "2 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Marine",
        "20–30 dk"
      ],
      [
        "Pişirme",
        "10 dk"
      ],
      [
        "Toplam",
        "40–50 dk"
      ]
    ],
    "time": "40–50 dk",
    "ingredients": [
      "300 g somon fileto",
      "150 g Freya Gurme İncir Balsamic Sosu",
      "2 tatlı kaşığı zeytinyağı",
      "Tuz",
      "Taze çekilmiş karabiber",
      "10–12 adet kuşkonmaz"
    ],
    "steps": [
      "Somon filetoyu iri küpler halinde kesin.",
      "Somonları 150 g Freya Gurme İncir Balsamic Sosu, zeytinyağı, tuz ve taze çekilmiş karabiberle harmanlayın.",
      "Buzdolabında 20–30 dakika marine edin.",
      "Tavayı iyice ısıtın. Marine edilmiş somonları tavaya alın ve çok fazla çevirmeden her yüzünü kızartarak yaklaşık 6–8 dakika pişirin.",
      "Kuşkonmazları ayrı bir tavada az miktarda zeytinyağı ve tuz ile 3–4 dakika, hafif diri kalacak şekilde soteleyin.",
      "Somonları kuşkonmazlarla birlikte sıcak servis edin."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni"
  },
  {
    "slug": "maviyemis-lavanta-soslu-citir-ekmek",
    "title": "Maviyemiş & Lavanta Soslu Çıtır Ekmek",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-citir-ekmek.webp?v=1790406175",
    "product": "Maviyemiş & Lavanta Sosu",
    "productSlug": "maviyemis-lavanta-sosu",
    "summary": "Kale, pancar otu, ceviz ve fıstıkla hazırlanan yeşillikli karışım; kızarmış ekmek üzerinde.",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "5 dk"
      ],
      [
        "Toplam",
        "20 dk"
      ]
    ],
    "time": "20 dk",
    "ingredients": [
      "8–10 adet kale yaprağı",
      "5–6 adet pancar otu yaprağı",
      "5–6 dal Frenk soğanı",
      "150 g ceviz içi",
      "150 g fıstık içi",
      "170 g Freya Gurme Maviyemiş & Lavanta Sosu",
      "120 ml zeytinyağı",
      "Bir tutam tuz",
      "Kızarmış ekmek dilimleri"
    ],
    "steps": [
      "Kale, pancar otu ve Frenk soğanını ince ince doğrayın ve derin bir karıştırma kabına alın.",
      "Ceviz ve fıstık içlerini iri şekilde doğrayıp yeşilliklere ekleyin.",
      "Freya Gurme Maviyemiş & Lavanta Sosu, zeytinyağı ve bir tutam tuzu blenderda pürüzsüz bir kıvam alana kadar çekin.",
      "Hazırladığınız sosu yeşilliklerin üzerine dökün ve tüm malzemeler sosla kaplanacak şekilde iyice karıştırın.",
      "Ekmek dilimlerini kızartın.",
      "Hazırladığınız yeşillikli karışımı kızarmış ekmeklerin üzerine bolca yerleştirip servis edin."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni"
  },
  {
    "slug": "maviyemis-lavanta-soslu-ilik-patates-salatasi",
    "title": "Maviyemiş & Lavanta Soslu Ilık Patates Salatası",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-patates.webp?v=1790406169",
    "product": "Maviyemiş & Lavanta Sosu",
    "productSlug": "maviyemis-lavanta-sosu",
    "summary": "Fırında çıtırlaşan patatesler, kuşkonmaz, kavrulmuş badem ve maviyemiş sosuyla.",
    "serves": "4 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Ön haşlama",
        "20–30 dk"
      ],
      [
        "Fırında pişirme",
        "30 dk"
      ],
      [
        "Toplam",
        "65–75 dk"
      ]
    ],
    "time": "65–75 dk",
    "ingredients": [
      "1 kg baby patates",
      "1 bağ kuşkonmaz",
      "50 g kavrulmuş badem",
      "50–60 g parmesan, rendelenmiş",
      "1 yemek kaşığı kapari",
      "½ demet dereotu",
      "Taze kekik",
      "Taze rendelenmiş muskat",
      "Tuz",
      "Taze çekilmiş karabiber",
      "Zeytinyağı"
    ],
    "steps": [
      "Baby patatesleri ortadan ikiye kesin. Tuzlu kaynar suda tamamen yumuşamadan, hafif diri kalacak şekilde 20–30 dakika ön haşlama yapın. Süzüp birkaç dakika dinlendirin.",
      "Patatesleri zeytinyağı, tuz, karabiber ve taze rendelenmiş muskat ile harmanlayın. Önceden ısıtılmış 200°C fırında 30 dakika, dışları iyice kızarıp çıtırlaşana kadar pişirin.",
      "Kuşkonmazları iri parçalar halinde kesin. Az miktarda zeytinyağı ile kısa süre soteleyerek hafif diri bırakın.",
      "Ayrı bir sos kabında 150 g Freya Gurme Maviyemiş & Lavanta Sosu, zeytinyağı, tuz ve taze çekilmiş karabiberi çırparak akışkan bir sos kıvamına getirin.",
      "Fırından çıkan sıcak patatesleri kuşkonmaz, kapari ve kavrulmuş badem ile birleştirin.",
      "Hazırladığınız Maviyemiş & Lavanta sosunu üzerine gezdirin ve patatesleri ezmeden nazikçe harmanlayın.",
      "İnce kıyılmış dereotu ve taze kekiği ekleyin. Servis tabağına aldıktan sonra üzerine bolca rendelenmiş parmesan ekleyerek tamamlayın."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni",
    "ingredientGroups": [
      {
        "title": "Salata için",
        "items": [
          "1 kg baby patates",
          "1 bağ kuşkonmaz",
          "50 g kavrulmuş badem",
          "50–60 g parmesan, rendelenmiş",
          "1 yemek kaşığı kapari",
          "½ demet dereotu",
          "Taze kekik",
          "Taze rendelenmiş muskat",
          "Tuz",
          "Taze çekilmiş karabiber",
          "Zeytinyağı"
        ]
      },
      {
        "title": "Maviyemiş & Lavanta sosu için",
        "items": [
          "150 g Freya Gurme Maviyemiş & Lavanta Sosu",
          "2–3 yemek kaşığı zeytinyağı",
          "Tuz",
          "Taze çekilmiş karabiber"
        ]
      }
    ]
  },
  {
    "slug": "zencefil-armut-soslu-mozzarella-omlet",
    "title": "Zencefil & Acılı Armut Soslu Mozzarella Omlet",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-omlet.webp?v=1790406158",
    "product": "Zencefil & Acılı Armut Sosu",
    "productSlug": "zencefil-acili-armut-sosu",
    "summary": "Eriyen mozzarella, hafif acılı armut sosu ve taze kekikle tavada hazırlanan omlet.",
    "serves": "1 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ],
      [
        "Pişirme",
        "7–8 dk"
      ],
      [
        "Toplam",
        "12–13 dk"
      ]
    ],
    "time": "12–13 dk",
    "ingredients": [
      "2 adet yumurta",
      "80–100 g rendelenmiş mozzarella",
      "2 dolu yemek kaşığı Freya Gurme Zencefil & Acılı Armut Sosu",
      "1 tatlı kaşığı Freya Gurme Acılı Zeytinyağı",
      "1 tutam tuz",
      "Taze kekik",
      "Çörek otu"
    ],
    "steps": [
      "Tavaya 1 tatlı kaşığı Freya Gurme Acılı Zeytinyağı ekleyin ve kısık-orta ateşte hafifçe ısıtın.",
      "Rendelenmiş mozzarellayı tavaya 6 eşit küçük küme halinde yerleştirin.",
      "2 dolu yemek kaşığı Freya Gurme Zencefil & Acılı Armut Sosunu mozzarella kümelerinin üzerine eşit şekilde paylaştırın.",
      "Ayrı bir kapta yumurtaları bir tutam tuz ile çırpın. Çırpılmış yumurtayı mozzarella ve sosun üzerine eşit şekilde dökün.",
      "Kısık-orta ateşte yumurta toparlanıp mozzarella tamamen eriyerek alt kısmı hafifçe kızarana kadar 7–8 dakika pişirin.",
      "Omleti spatula yardımıyla ikiye katlayın. Üzerine taze kekik ve çörek otu ekleyerek sıcak servis edin."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni"
  },
  {
    "slug": "kuru-meyveli-granola-kumkuat-bowl",
    "title": "Kuru Meyveli Granola & Kumkuat Bowl",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-kumkuat.webp?v=1790406164",
    "product": "Kuru Meyveli Granola",
    "productSlug": "kuru-meyveli-granola",
    "summary": "Tahinli süzme yoğurt, çıtır granola, Antep fıstığı ve taze kumkuat.",
    "serves": "1 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ],
      [
        "Pişirme",
        "Yok"
      ],
      [
        "Toplam",
        "5 dk"
      ]
    ],
    "time": "5 dk",
    "ingredients": [
      "180 g süzme yoğurt",
      "1 yemek kaşığı tahin",
      "15 g file Antep fıstığı",
      "40–45 g Freya Gurme Kuru Meyveli Granola",
      "3–4 adet taze kumkuat"
    ],
    "steps": [
      "Süzme yoğurdu tahin ve file Antep fıstığının bir kısmıyla karıştırın.",
      "Hazırladığınız yoğurt karışımını servis kasesinin tabanına yayın.",
      "Üzerine 40–45 g Freya Gurme Kuru Meyveli Granola ekleyin.",
      "Kumkuatları iyice yıkayın ve kabuklarıyla birlikte ince halkalar halinde dilimleyerek granolanın üzerine yerleştirin.",
      "Kalan file Antep fıstığını üzerine serpiştirerek tamamlayın."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni"
  },
  {
    "slug": "cikolatali-granola-bowl",
    "title": "Çikolatalı Granola Bowl",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-cikolata.webp?v=1790406138",
    "product": "Çikolatalı Granola",
    "productSlug": "cikolatali-granola",
    "summary": "Maviyemiş, badem ezmesi ve bitter çikolatayla tamamlanan beş dakikalık bir kase.",
    "serves": "1 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ],
      [
        "Pişirme",
        "Yok"
      ],
      [
        "Toplam",
        "5 dk"
      ]
    ],
    "time": "5 dk",
    "ingredients": [
      "180 g süzme yoğurt",
      "45 g Freya Gurme Çikolatalı Granola",
      "1 dolu tatlı kaşığı badem ezmesi",
      "15 g kavrulmuş badem",
      "40–50 g taze maviyemiş",
      "8–10 g bitter çikolata, ince rendelenmiş"
    ],
    "steps": [
      "Süzme yoğurdu servis kasesinin tabanına eşit şekilde yayın.",
      "Üzerine 45 g Freya Gurme Çikolatalı Granola ekleyin.",
      "Taze maviyemişleri ve kavrulmuş bademleri granolanın üzerine yerleştirin.",
      "Badem ezmesini hafifçe akışkan hale getirerek kasenin üzerine gezdirin.",
      "Son olarak bitter çikolatayı ince şekilde rendeleyerek üzerine serpiştirin."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni"
  },
  {
    "slug": "ejder-meyveli-matcha-bowl",
    "title": "Ejder Meyveli Matcha Bowl",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-editorial-matcha.webp?v=1790406186",
    "product": "Matcha Granola",
    "productSlug": "matcha-granola",
    "summary": "Ejder meyveli pembe yoğurdun üzerinde matcha granola, beyaz çikolata ve kuru mango.",
    "serves": "1 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ],
      [
        "Pişirme",
        "Yok"
      ],
      [
        "Toplam",
        "5 dk"
      ]
    ],
    "time": "5 dk",
    "ingredients": [
      "180 g süzme yoğurt",
      "110 g Freya Gurme Ejder Meyvesi Sosu",
      "40–45 g Freya Gurme Matcha Granola",
      "20 g Antep fıstığı",
      "15–20 g beyaz çikolata",
      "4–5 parça kuru mango"
    ],
    "steps": [
      "Süzme yoğurdu 110 g Freya Gurme Ejder Meyvesi Sosu ile homojen, pembe ve kremsi bir kıvam alana kadar karıştırın.",
      "Hazırladığınız yoğurt karışımını servis kasesinin tabanına yayın.",
      "Üzerine 40–45 g Freya Gurme Matcha Granola ekleyin.",
      "Antep fıstığını, beyaz çikolata parçalarını ve kuru mangoyu üzerine yerleştirin.",
      "Tüm malzemeleri dengeli şekilde dağıtarak servis edin."
    ],
    "source": "FREYA TARIFLER.pdf",
    "collection": "yeni"
  }
] .concat(window.FREYA_RECIPES || []);
